import { Element } from '../../../../common/html/element'
import { DateRange } from './DateRange'
import classes from './index.module.scss'
import { SearchCriteria } from './SearchCriteria'

export const Filter = () => {
  return (
    <Element className={classes.filter}>
      <SearchCriteria />
      <Element
        className={classes.verticalLine}
        style={{ backgroundColor: '#D5D5D5' }}
      />
      <DateRange />
    </Element>
  )
}
